module.exports = __webpack_public_path__ + "img/pattern.41692e6d.png";